import { TASKS_STATUS } from '../../ContentLists/TaskList/constants'

export const WORK_TIME_ACCEPTED_ID = 'worktimeAcceptedStatusEnd'
export const REVIEW_FRONTLINE_STATUSES = [
  TASKS_STATUS.reviewFrontline,
  TASKS_STATUS.reviewFrontlineSeen,
  TASKS_STATUS.reviewFrontlineUnseen,
]
export const REVIEW_OFFICE_STATUSES = [TASKS_STATUS.requestChange, TASKS_STATUS.reviewOfficeUnseen]
